import { CardId } from './card-id';
import { CardDisclosureStatus } from '../logic-types';

export class CardDisclosure {
  public disclosureStatus: CardDisclosureStatus;
  public cardId?: CardId;

  constructor(disclosureStatus: CardDisclosureStatus, cardId?: CardId) {
    this.disclosureStatus = disclosureStatus;
    this.cardId = cardId;
  }
}
